<template>
  <AppIcon
    class="h-4 w-4 p-1"
    :class="{
      'bg-primary text-primary-content rounded ml-4': !compact,
      'p-3 hover:bg-primary hover:text-primary-content rounded': compact
    }"
    :icon="['fa-solid', icon]"
  />
</template>

<script setup lang="ts">
const props = defineProps<{
  icon: string;
  compact: boolean;
}>();

const { icon, compact } = toRefs(props);
</script>

<style scoped></style>
